/**
 * Optimized base64 encode using btoa on the browser rather than shipping node_modules/buffer to the browser
 */
export const base64encode =
    typeof window === "undefined"
        ? // nodejs
          (str: string) => Buffer.from(str).toString("base64")
        : // browser
          (str: string) => btoa(str);
